"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeMap = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _antd = require("antd");
var _react = require("react");
var _deepUpdateObj = _interopRequireDefault(require("../utils/deepUpdateObj"));
var _getValueByPath = _interopRequireDefault(require("../utils/getValueByPath"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultDark = _antd.theme.darkAlgorithm,
  compactAlgorithm = _antd.theme.compactAlgorithm,
  defaultAlgorithm = _antd.theme.defaultAlgorithm;
var themeMap = exports.themeMap = {
  dark: defaultDark,
  compact: compactAlgorithm,
  default: defaultAlgorithm
};
var useControlledTheme = function useControlledTheme(_ref) {
  var _themeRef$current2;
  var customTheme = _ref.theme,
    defaultTheme = _ref.defaultTheme,
    onChange = _ref.onChange;
  var _useState = (0, _react.useState)(customTheme !== null && customTheme !== void 0 ? customTheme : defaultTheme),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    theme = _useState2[0],
    setTheme = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    infoFollowPrimary = _useState4[0],
    setInfoFollowPrimary = _useState4[1];
  var themeRef = (0, _react.useRef)(theme);
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    setRenderHolder = _useState6[1];
  var forceUpdate = function forceUpdate() {
    return setRenderHolder(function (prev) {
      return prev + 1;
    });
  };
  var getNewTheme = function getNewTheme(newTheme, force) {
    var result = _objectSpread({}, newTheme);
    if (infoFollowPrimary || force) {
      var newToken = _objectSpread({}, newTheme.config.token);
      if (newToken.colorPrimary) {
        newToken.colorInfo = newToken.colorPrimary;
      } else {
        delete newToken.colorInfo;
      }
      if (Object.keys(newToken).length > 0) {
        result.config = _objectSpread(_objectSpread({}, newTheme.config), {}, {
          token: newToken
        });
      } else {
        delete result.config.token;
      }
    }
    return result;
  };
  var handleSetTheme = function handleSetTheme(newTheme) {
    onChange === null || onChange === void 0 || onChange(getNewTheme(newTheme));
    if (!customTheme) {
      setTheme(getNewTheme(newTheme));
    }
  };
  var handleResetTheme = function handleResetTheme(path) {
    var _themeRef$current;
    var newConfig = _objectSpread({}, theme.config);
    newConfig = (0, _deepUpdateObj.default)(newConfig, path, (0, _getValueByPath.default)((_themeRef$current = themeRef.current) === null || _themeRef$current === void 0 ? void 0 : _themeRef$current.config, path));
    handleSetTheme(_objectSpread(_objectSpread({}, theme), {}, {
      config: newConfig
    }), path);
  };
  var handleAbortTheme = function handleAbortTheme(path) {
    var newConfig = _objectSpread({}, theme.config);
    newConfig = (0, _deepUpdateObj.default)(newConfig, path, undefined);
    handleSetTheme(_objectSpread(_objectSpread({}, theme), {}, {
      config: newConfig
    }), path);
  };
  var getCanReset = function getCanReset(origin, current) {
    return function (path) {
      return (0, _getValueByPath.default)(origin, path) !== (0, _getValueByPath.default)(current, path);
    };
  };

  // Controlled theme change
  (0, _react.useEffect)(function () {
    if (customTheme) {
      setTheme(customTheme);
    }
  }, [customTheme]);
  var handleInfoFollowPrimaryChange = function handleInfoFollowPrimaryChange(value) {
    setInfoFollowPrimary(value);
    if (value) {
      setTheme(getNewTheme(theme, true));
    }
  };
  return {
    theme: _objectSpread(_objectSpread({}, theme), {}, {
      onThemeChange: function onThemeChange(config, path) {
        return handleSetTheme(_objectSpread(_objectSpread({}, theme), {}, {
          config: config
        }), path);
      },
      onReset: handleResetTheme,
      onAbort: handleAbortTheme,
      getCanReset: getCanReset((_themeRef$current2 = themeRef.current) === null || _themeRef$current2 === void 0 ? void 0 : _themeRef$current2.config, theme.config)
    }),
    infoFollowPrimary: infoFollowPrimary,
    onInfoFollowPrimaryChange: handleInfoFollowPrimaryChange,
    updateRef: function updateRef() {
      themeRef.current = theme;
      forceUpdate();
    }
  };
};
var _default = exports.default = useControlledTheme;